export const PRICING_DETAILS_PRODUCT_AREA = 'pricing details';
export const EDIT_ESTIMATE_LOCATION = 'storefront pricing block';

export const decisionArea = {
	SERVICES: 'step 1 - services',
	GUEST_COUNT: 'step 2 - guest count',
	WEDDING_DATE: 'step 3 - wedding date',
};

export const DECISION_AREA_BY_STEP: Record<number, string> = {
	1: decisionArea.SERVICES,
	2: decisionArea.GUEST_COUNT,
	3: decisionArea.WEDDING_DATE,
};

export const ESTIMATE_REQUEST_FLOW_SOURCE_CONTENT = 'estimate request flow';
